var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 8.25H1.5C1.30109 8.25 1.11032 8.17098 0.96967 8.03033C0.829018 7.88968 0.75 7.69891 0.75 7.5V1.5C0.75 1.30109 0.829018 1.11032 0.96967 0.96967C1.11032 0.829018 1.30109 0.75 1.5 0.75H7.875C8.07391 0.75 8.26468 0.829018 8.40533 0.96967C8.54598 1.11032 8.625 1.30109 8.625 1.5V3.0225L10.6575 1.57125C10.7135 1.5314 10.7793 1.50769 10.8478 1.50271C10.9164 1.49774 10.9849 1.51168 11.0461 1.54302C11.1072 1.57437 11.1586 1.62191 11.1945 1.68045C11.2305 1.739 11.2497 1.80629 11.25 1.875V7.125C11.2497 7.19371 11.2305 7.261 11.1945 7.31955C11.1586 7.37809 11.1072 7.42563 11.0461 7.45697C10.9849 7.48832 10.9164 7.50226 10.8478 7.49729C10.7793 7.49231 10.7135 7.4686 10.6575 7.42875L8.625 5.9775V7.5C8.625 7.69891 8.54598 7.88968 8.40533 8.03033C8.26468 8.17098 8.07391 8.25 7.875 8.25Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraLight);
export default __webpack_public_path__ + "static/media/camera_light.3dc8ea8b458d4d57e7974c2dee16023e.svg";
export { ForwardRef as ReactComponent };